<template>
  <div
    :class="{
      'border-solid border-1 border-yellow-500 rounded-lg': isBorder,
      'flex justify-between items-center md:py-4 md:mx-2': true,
    }"
  >
    <!-- dropoff::{{ this.$store.state.main.pickUpAndDropOffTiming.dropOffTime }} -->
    <!-- Pick up and drop off div  -->
    <div class="flex md:w-10/12">
      <!-- pick up info  -->
      <div class="p-4 rounded-lg md:w-5/12">
        <p class="font-semibold w-full">
          {{ $store.state.main.bookingDetails.formData.pickupPlace }}
        </p>
        <p class="w-full">
          {{ formattedDateTime.pickupDateTime }}
        </p>
      </div>
      <!-- Icon right   -->
      <div class="hidden md:flex justify-center items-center md:w-1/12">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m8.25 4.5 7.5 7.5-7.5 7.5"
          />
        </svg>
      </div>

      <!-- drop-off info  -->
      <div class="hidden md:flex p-4 rounded-lg md:w-6/12">
        <div class="flex items-center">
          <div class="ml-2">
            <p class="font-semibold">
              {{ $store.state.main.bookingDetails.formData.dropOffPlace }}
            </p>
            <p>
              {{ formattedDateTime.dropoffDateTime }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- Edit button  -->
    <div
      v-if="isEditButton"
      class="flex items-center justify-center md:justify-end w-2/12"
    >
      <button
        @click="$router.go(-1)"
        class="bg-green-700 hover:bg-green-800 cursor-pointer text-white px-4 py-2 rounded self-start lg:self-center border-none mr-3 duration-300"
      >
        Edit
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      totalDays: 0,
      extraHours: 0,
    };
  },
  props: {
    isEditButton: {
      type: Boolean,
      required: true,
    },
    isBorder: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    formattedDateTime() {
      const formatDate = (dateString) => {
        const date = new Date(dateString);
        const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        const months = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        return `${days[date.getDay()]}, ${date.getDate()} ${
          months[date.getMonth()]
        } ${date.getFullYear()}`;
      };

      const formatTime = (timeString) => {
        const [hours, minutes] = timeString.split(":");
        const ampm = hours >= 12 ? "PM" : "AM";
        const hour = hours % 12 || 12;
        return `${hour}:${minutes} ${ampm}`;
      };

      const bookingDetails = this.$store.state.main.bookingDetails.formData;

      const pickupDateTime = `${formatDate(
        bookingDetails.pickupDate
      )}, ${formatTime(bookingDetails.pickupTime)}`;
      const dropoffDateTime = `${formatDate(
        bookingDetails.dropoffDate
      )}, ${formatTime(bookingDetails.dropoffTime)}`;
      this.getTimingDetails(pickupDateTime, dropoffDateTime);
      return { pickupDateTime, dropoffDateTime };
    },
  },
  methods: {
    getTimingDetails(pickup, dropOff) {
      this.$store.state.main.bookingDetails.pickUpAndDropOffTiming.pickUpTime =
        pickup;
      this.$store.state.main.bookingDetails.pickUpAndDropOffTiming.dropOffTime =
        dropOff;
    },
    parseDate(dateString) {
      const [dayName, day, month, year, time] = dateString.split(/[\s,]+/);
      const months = {
        Jan: 0,
        Feb: 1,
        Mar: 2,
        Apr: 3,
        May: 4,
        Jun: 5,
        Jul: 6,
        Aug: 7,
        Sep: 8,
        Oct: 9,
        Nov: 10,
        Dec: 11,
      };
      const [hours, minutes] = time.split(":").map(Number);
      const ampm = time.split(" ")[1];
      const hour = ampm === "PM" && hours !== 12 ? hours + 12 : hours;
      return new Date(year, months[month], day, hour, minutes);
    },
    calculateDifference() {
      const pickUp = this.parseDate(
        this.$store.state.main.bookingDetails.pickUpAndDropOffTiming.pickUpTime
      );
      const dropOff = this.parseDate(
        this.$store.state.main.bookingDetails.pickUpAndDropOffTiming.dropOffTime
      );

      const diffMilliseconds = dropOff - pickUp;
      const totalHours = diffMilliseconds / (1000 * 60 * 60);
      const totalDays = Math.floor(totalHours / 24);
      const extraHours = totalHours % 24;

      this.totalDays = totalDays;
      this.extraHours = extraHours.toFixed(2);
      this.saveDaysAndHours(totalDays, extraHours.toFixed(2));
    },
    saveDaysAndHours(totalDays, extraHours) {
      this.$store.state.main.bookingDetails.pickUpAndDropOffTiming.totalDays =
        totalDays;
      this.$store.state.main.bookingDetails.pickUpAndDropOffTiming.extraHours =
        extraHours;
    },
  },
  mounted() {
    this.calculateDifference();
  },
};
</script>

<style scoped></style>
